import { MainAdminLayout } from "layout";
import {
  CustomerPage,
  CustomersPage,
  MyProxiesPage,
  PaymentStatusPage,
  SettingsPage,
  StatisticsPage,
} from "pages/admin";
import { redirect, RouteObject } from "react-router-dom";

export const mainAdminRouter: RouteObject[] = [
  {
    path: "*",
    loader() {
      return redirect(process.env.NODE_ENV === "production" ? "/" : "admin");
    },
  },
  {
    path: process.env.NODE_ENV === "production" ? "/" : "admin",
    element: <MainAdminLayout />,
    children: [
      {
        index: true,
        element: <MyProxiesPage />,
      },
      {
        path: "statistics",
        element: <StatisticsPage />,
      },
      {
        path: "customers",
        element: <CustomersPage />,
      },
      {
        path: "customers/:id",
        element: <CustomerPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      }
    ],
  },
  {
    path: (process.env.NODE_ENV === "production" ? "" : "admin/") + "payment-status",
    element: <PaymentStatusPage />,
  },
];
